var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryLower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 225,
    viewBox: "0 0 262 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0894 22.7955C60.512 30.1395 14.7677 35.801 0.141602 32.741C0.141602 75.5813 1.65465 179.01 1.65465 197.982C1.65465 216.954 15.7764 222.717 22.8373 223.227C87.1416 223.992 220.289 225.063 238.446 223.227C256.602 221.391 261.142 205.632 261.142 197.982V0.610317C239.959 -5.50971 201.528 66.5537 171.872 61.0457C134.802 54.1606 106.811 13.6154 81.0894 22.7955Z",
    fill: "#8CC9DC",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryLower);
export default __webpack_public_path__ + "static/media/countryLower.394cec237013380f1cf765b73f871e37.svg";
export { ForwardRef as ReactComponent };